import React, { useEffect, useState, useRef } from 'react';
import { useRecoilState } from 'recoil';
import { ActiveEvents, newEvent, toaster } from '../Recoil/ActiveEvents';
import { format } from 'date-fns';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext'; // Import InputText for filters

const ShowUserList = () => {
  const [notify, setNotify] = useRecoilState(toaster);
  const [eventID, setEventID] = useRecoilState(newEvent);
  const [activeEvents, setActiveEvents] = useRecoilState(ActiveEvents);
  const dt = useRef(null);  // Ref for the DataTable

  const [users, setUsers] = useState([]);
  const [filters, setFilters] = useState(null); // State to store filters

  const paginatorLeft = <Button type="button" icon="pi pi-refresh" text />;
  const paginatorRight = <Button type="button" icon="pi pi-download" text />;

  useEffect(() => {
    if (eventID) {
      let eventURI = process.env.REACT_APP_API_URL + "/Registration/GetAllRegistrationDetails";
      fetch(eventURI, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(eventID)
      })
        .then(response => {
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          return response.json();
        })
        .then((result) => {
          setUsers(result.AllRegistrationDetails);
        })
        .catch((error) => console.error(error));
    }
  }, [eventID]);

  const fullNameTemplate = (rowData) => {
    return `${rowData.FirstName} ${rowData.LastName}`;
  };

  const paymentStatus = (rowData) => {
    return `${!!rowData.PaymentId ? "Paid" : "Failed"}`;
  };

  const dateTemplate = (rowData) => {
    return format(new Date(rowData.createdOn), 'dd_MMM_yyyy');
  };

  return (
    <div className='max-w-[95%] mx-auto px-4 py-12'>
      <div className="flex justify-between">
        <h1 className='text-t-20'>Registered Users</h1>
        <Button label="Export" icon="pi pi-upload" onClick={() => dt.current.exportCSV()} />
      </div>

      <DataTable
        ref={dt}
        value={users}
        paginator
        rows={5}
        rowsPerPageOptions={[5, 10, 25, 50]}
        tableStyle={{ minWidth: '50rem' }}
        paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
        currentPageReportTemplate="{first} to {last} of {totalRecords}"
        paginatorLeft={paginatorLeft}
        paginatorRight={paginatorRight}
        exportFilename="users"
        filters={filters} // Pass filters here
        onFilter={(e) => setFilters(e.filters)} // Set filters on change
      >
        <Column header="First Name" field="FirstName" style={{ width: '25%' }} filter filterPlaceholder="Search First Name"  />
        <Column header="Last Name" field="LastName" style={{ width: '25%' }} filter filterPlaceholder="Search Last Name" />
        <Column header="Name" body={fullNameTemplate} style={{ width: '25%' }} />
        <Column field="Gender" header="Gender" style={{ width: '25%' }} filter filterPlaceholder="Search Gender" />
        <Column field="Emailid" header="Email ID" style={{ width: '25%' }} filter filterPlaceholder="Search Email" />
        <Column field="MobileNo" header="Mobile No" style={{ width: '25%' }} filter filterPlaceholder="Search Mobile No" />
        <Column header="ID Proof Type" field="IdProofType" style={{ width: '25%' }} filter filterPlaceholder="Search ID Proof Type" />
        <Column header="ID Proof #" field="IdProofNumber" style={{ width: '25%' }} filter filterPlaceholder="Search ID Proof #" />
        <Column header="Payment Status" body={paymentStatus} style={{ width: '25%' }} />
        <Column header="Payment Status" field="PaymentStatus" style={{ width: '25%' }} hidden />
        <Column header="T-Shirt Size" field="TShirtSize" style={{ width: '25%' }} hidden />
        <Column header="Name To Display In T-Shirt" field="NameToDisplayInTshort" style={{ width: '25%' }} hidden />
        <Column header="Created On" field="createdOn" style={{ width: '25%' }} hidden />
        <Column header="Created On" body={dateTemplate} style={{ width: '25%' }} />
        <Column field="BloodGroup" header="Blood Group" style={{ width: '25%' }} hidden />
      </DataTable>
    </div>
  );
};

export default ShowUserList;
